module.exports = __webpack_public_path__ + "img/jack_the_seller.6f38ecfe.png";